import * as Joi from 'joi';
import _ from 'lodash';
import { CLIENT_STATE_VERSIONS } from '../client-state-type';
import { ClientStateV4dot2Schema } from './types/v4dot2';
import { upgraderFn as upgradeV1ToV2dot1 } from './upgraders/v1-to-v2dot1';
import { upgraderFn as upgradeV2ToV2dot1 } from './upgraders/v2-to-v2dot1';
import { upgraderFn as upgradeV2dot1ToV2dot2 } from './upgraders/v2dot1-to-v2dot2';
import { upgraderFn as upgradeV2dot2ToV3 } from './upgraders/v2dot2-to-v3';
import { upgraderFn as upgradeV3ToV4dot1 } from './upgraders/v3-to-v4dot1';
import { upgraderFn as upgradeV4ToV4dot1 } from './upgraders/v4-to-v4dot1';
import { upgraderFn as upgradeV4Dot1ToV4dot2 } from './upgraders/v4dot1-to-v4dot2';
export const LATEST_CLIENT_STATE_SCHEMA = ClientStateV4dot2Schema;
const clientStateUpgradeChain = {
    null: {
        returnVersion: CLIENT_STATE_VERSIONS.V2dot1,
        upgraderFn: upgradeV1ToV2dot1,
    },
    [CLIENT_STATE_VERSIONS.V2]: {
        returnVersion: CLIENT_STATE_VERSIONS.V2dot1,
        upgraderFn: upgradeV2ToV2dot1,
    },
    [CLIENT_STATE_VERSIONS.V2dot1]: {
        returnVersion: CLIENT_STATE_VERSIONS.V2dot2,
        upgraderFn: upgradeV2dot1ToV2dot2,
    },
    [CLIENT_STATE_VERSIONS.V2dot2]: {
        returnVersion: CLIENT_STATE_VERSIONS.V3,
        upgraderFn: upgradeV2dot2ToV3,
    },
    [CLIENT_STATE_VERSIONS.V3]: {
        returnVersion: CLIENT_STATE_VERSIONS.V4dot1,
        upgraderFn: upgradeV3ToV4dot1,
    },
    [CLIENT_STATE_VERSIONS.V4]: {
        returnVersion: CLIENT_STATE_VERSIONS.V4dot1,
        upgraderFn: upgradeV4ToV4dot1,
    },
    [CLIENT_STATE_VERSIONS.V4dot1]: {
        upgraderFn: upgradeV4Dot1ToV4dot2,
    },
};
export function upgradeClientStateToLatestVersion(vizModel) {
    let clientState = vizModel.clientState;
    if (!_.isNil(vizModel.vizProps) &&
        !_.isEmpty(vizModel.vizProps) &&
        !_.isNil(vizModel.vizProps.version)) {
        clientState = vizModel.vizProps;
    }
    let clientStateVersion = !_.isNil(clientState.version)
        ? clientState.version
        : null;
    let currVersionUpgradeArc = clientStateUpgradeChain[clientStateVersion];
    while (!_.isNil(currVersionUpgradeArc) &&
        !_.isNil(currVersionUpgradeArc.upgraderFn)) {
        clientState = currVersionUpgradeArc.upgraderFn(clientState, vizModel);
        clientStateVersion = currVersionUpgradeArc.returnVersion || undefined;
        currVersionUpgradeArc = clientStateUpgradeChain[clientStateVersion];
    }
    Joi.assert(clientState, LATEST_CLIENT_STATE_SCHEMA);
    return clientState;
}
//# sourceMappingURL=upgrader.js.map